var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55463 10.2047L0.196377 5.84647C-0.0654589 5.58463 -0.0654589 5.1601 0.196377 4.89824L1.14459 3.95C1.40642 3.68814 1.83098 3.68814 2.09282 3.95L5.02875 6.8859L11.3172 0.5975C11.579 0.335664 12.0036 0.335664 12.2654 0.5975L13.2136 1.54573C13.4755 1.80757 13.4755 2.23211 13.2136 2.49397L5.50286 10.2048C5.241 10.4666 4.81647 10.4666 4.55463 10.2047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.16b62e06306e6e7eaa108ae1f8e8a62b.svg";
export { ForwardRef as ReactComponent };